import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import Autocomplete from '@mui/material/Autocomplete';
import TableSortLabel from '@mui/material/TableSortLabel'
import Typography from '@mui/material/Typography'
import sendsvgrepo from '../images/send-svgrepo-.svg'
import InputBase from '@mui/material/InputBase'
import Paper from '@mui/material/Paper'
import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'
import AddIcon from '@material-ui/icons/Add'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { visuallyHidden } from '@mui/utils'
import AppBar from '../components/app-bar'
import { MenuItem, CircularProgress, Button, Dialog, DialogTitle, DialogActions, AccordionDetails, makeStyles, Select, TextField, Accordion, AccordionSummary, InputLabel } from '@material-ui/core'
import { customTheme } from '../styling'
import axios from '../axios'
import moment from 'moment'
import GeneralError from '../components/error'
import SnackBar from '../components/snackbar'
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../constants'
import { Divider, List, ListItem, Popover, Tab, Tabs } from '@mui/material'
import { getRoleUserIdFromToken } from '../utils'
import Grid2 from '@mui/material/Unstable_Grid2'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import InfiniteScroll from 'react-infinite-scroll-component'
import IconButton from '@mui/material/IconButton'
import { SearchBar } from '../components/search-bar.tsx'


const useStyles = makeStyles((theme) => ({
    generateCodeContainer: {
        width: '100%',
        marginTop: '1.5rem',
    },
    appBarSpacer: theme.mixins.toolbar,
    uploadFile: {
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        overflowX: 'hidden',
        marginLeft: '1rem',
        width: '90%',
        height: '20vh',
        display: 'flex',
        textAlign: 'center',
        border: `1px solid ${customTheme.colors.ui.grey}`,
        borderStyle: 'dotted',
        marginBottom: '0.3rem'
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        height: '100vh',
        overflow: 'auto',
    },
    title: {
        color: 'black',
    },
    selectBoxMain: {
        width: '80vw',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        position: 'absolute',
        top: '40%',
        cursor: 'pointer'
    },
    selectBox: {
        width: '35%',
        backgroundColor: customTheme.colors.ui.ligthBlue,
        padding: '1.5rem 3.5rem',
        textAlign: 'center',
        '&:hover': {
            cursor: 'pointer',
            opacity: '0.6'
        },
    },
    loadingContainer: {
        position: 'absolute',
        top: '50%',
        left: '50%'
    },
    formControl: {
        minWidth: 300, marginRight: '1.5rem'
    },
    dialogActions: {
        marginTop: '1rem'
    },
    contentContainer: {
        padding: '2rem'
    },

}))



const rows = []

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1
    }
    if (b[orderBy] > a[orderBy]) {
        return 1
    }
    return 0
}



const headCells = [
    {
        id: 'numOrdine',
        numeric: false,
        disablePadding: false,
        label: 'Nr ordine',
    },
    {
        id: 'dateOfOrdine',
        numeric: false,
        disablePadding: false,
        label: 'Data ordine',
    },
    {
        id: 'client',
        numeric: false,
        disablePadding: false,
        label: 'Cliente',
    },
    {
        id: 'numberOfProducts',
        numeric: false,
        disablePadding: false,
        label: 'Nr prodotti',
    },
    {
        id: 'codeProducts',
        numeric: false,
        disablePadding: false,
        label: 'Codice prodotti',
    },
    {
        id: 'agents',
        numeric: false,
        disablePadding: false,
        label: 'Agente',
    },
]

const EnhancedTableHead = (props) => {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property)
    }
   
    const roleUserId = getRoleUserIdFromToken()
    const headCellsFormatted = roleUserId === 2 ? headCells.slice(0,5) : headCells
    return (
        <TableHead style={{ backgroundColor: customTheme.colors.ui.greyLight, }}>
            <TableRow>
                {headCellsFormatted.map((headCell) => (
                    <TableCell
                        style={{ color: 'black' }}
                        key={headCell.id}
                        align={'left'}
                        padding={'normal'}
                    >
                        {headCell.label}
                    </TableCell>

                ))}
                <TableCell

                > </TableCell>
            </TableRow>
        </TableHead>
    )
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const Dashboard = () => {
    const [order, setOrder] = React.useState('asc')
    const [orderBy, setOrderBy] = React.useState('calories')
    const [selected, setSelected] = React.useState([])
    const [page, setPage] = React.useState(0)
    const [rowsPerPage, setRowsPerPage] = React.useState(5)
    const [listOrders, setListOrders] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const [addOrderOpen, setAddOrderOpen] = useState(false)
    const [client, setClient] = useState('')
    const [creatingOrder, setCreatingOrder] = useState(false)
    const [clients, setClients] = useState([])
    const [products, setProducts] = useState([])
    const [confirmDelete, setConfirmDelete] = useState(null)
    const [product, setProduct] = useState(null)
    const [qtyCartoni, setQtyCartoni] = useState(0)
    const [priceCartoni, setPriceCartoni] = useState(0)
    const [confirmSendOrder,  setConfirmSendOrder] = useState(false)
    const [nota, setNota] = useState(null)
    const [tab, setTab] = useState(0)
    const [anchorElModifyOrder, setAnchorElModifyOrder] = useState(null)
    const [currentOrder, setCurrentOrder] = useState(null)
    const classes = useStyles()
    const { enqueueSnackbar } = SnackBar.Consumer()
    const [currentInputSearch, setCurrentInputSearch] = useState('')
    const [listCount, setListCount] = useState(1)
    const [productList, setProductList] = useState([])
    const [currentChange, setCurrentChange] = useState(null)
    const [sendingOrder,  setSendingOrder] = useState(false)
    const [currentOrderSend, setCurrentOrderSend] = useState(null)
    const openModifyOrder = Boolean(anchorElModifyOrder)
    const idModifyOrder = openModifyOrder ? 'simple-popover-modify-order' : undefined
    const history = useHistory()
    const roleUserId = getRoleUserIdFromToken()
    const first = 30
    const [hasNextPage, setHasNextPage] = useState(false)
    const [after, setAfter] = useState(0)
    const [loadingMore, setLoadingMore] = useState(false)  

    
    
    const hasProducts = productList.some(
        (item) => item?.product?.id && Number(item.quantity) > 0
    )
    const canSaveOrder = Boolean(client) && hasProducts

    const getOrders = async (search = null, afterQuery = 0) => {
        let url = `/get-list-orders?first=${first}&after=${afterQuery}`
        if (search) {
            url = `/get-list-orders?search=${currentInputSearch}&first=${first}&after=${afterQuery}`
        }
        const orders = await axios.get(url)
        
        return {listOrders: orders.data.listOrders, hasNextPage:orders.data.hasNextPage}
    }

    const getInitialData = async () => {
        const [orders, clients, products] = await Promise.all([
            getOrders(),
            axios.get(`/get-list-clients`),
            axios.get(`/get-list-products`),

        ])


        const productsAll = [{label: 'Ultimi Acquistati', name:'Ultimi acquistati'}, ...products.data.listProducts.map((product) => ({ ...product, label: `(${product.code}) ${product.name}` }))]
        return { orders: orders.listOrders, hasNextPage:orders.hasNextPage, clients: clients.data, products: productsAll }
    }


    useEffect(() => {
        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        const currentId = urlParams.get('id')
        
        if(currentId){
            const order = listOrders.find(({id}) => id === Number(currentId))
            if(order){
                setAddOrderOpen(true)
                setCurrentOrder(order)
                setClient(order?.client?.id)
                const products = [...order.orderProducts.map((pr) => ({
                    ...pr, productId: pr.productId, quantity: pr.quantity, price: pr.price
                }))]
                setProductList(products)
            }
        }
     
    }, [location.search])
   
    useEffect(() => {
        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        const currentId = urlParams.get('id')
        setLoading(true)
        getInitialData().then((res) => {
            setClients(res.clients)
            setProducts(res.products.map((product) => ({...product, name:product.code ? `(${product.code}) ${product.name}` : product.name})))
            setHasNextPage(res.hasNextPage)
            setListOrders(res.orders)
            if(currentId){
                const order = res.orders.find(({id}) => id === Number(currentId))
                if(order){
                    setAddOrderOpen(true)
                    setCurrentOrder(order)
                    setClient(order?.client?.id)
                    const products = [...order.orderProducts.map((pr) => ({
                        ...pr, productId: pr.productId, quantity: pr.quantity, price: pr.price
                    }))]
    
                    setProductList(products)
                }
               
            }
        }).catch((error) => {
            setError(true)
        }).finally(() => {
            setLoading(false)
        })
    }, [])


    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc'
        setOrder(isAsc ? 'desc' : 'asc')
        setOrderBy(property)
    }



    const handleSave = () => {
        const body = {
            clientId: client,
            statusId: 1,
            listOrders: productList.map((order) => {
                return {code:order.product.code, name:order.product.name, id:order.product.name, quantity: order.quantity}
            }),
            submittedBy:roleUserId
        }

        if (currentOrder) {
            body.id = currentOrder.id
        }

        setCreatingOrder(true)
        axios.post(`/create-order`, body).then(() => {
            setClient(null)
            setProduct(null)
            setPriceCartoni(null)
            setProductList([])
            setQtyCartoni(null)
            setAddOrderOpen(false)
            setCurrentOrder(null)
            enqueueSnackbar({ variant: 'success', message: currentOrder ? 'Ordine salvato correttamente' : 'Ordine creato correttamente' })
            getInitialData().then((res) => {
                setClients(res.clients)
                setHasNextPage(res.hasNextPage)
                setProducts(res.products.map((product) => ({...product, name: product.code ? `(${product.code}) ${product.name}` : product.name})))
                setListOrders(res.orders)
            }).catch((error) => {
                setError(true)
            }).finally(() => {
                setLoading(false)
            })

        }).catch((error) => {
            console.log(error)
            enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
        }).finally(() => {
            setCreatingOrder(false)
        })
    }

    const handleInputSearchChange = (event) => {
        setCurrentInputSearch(event.target.value)
    }

    const handleSearchOrders = () => {
        setLoading(true)
        getOrders(currentInputSearch).then((res) => {
            setHasNextPage(res.hasNextPage)
            setListOrders(res.listOrders)
            setLoading(false)
        }).catch(() => {
            setLoading(false)
            enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
                variant: 'error',
            })

        })
    }

    const handleClearInput = () => {
        setAfter(0)
        setCurrentInputSearch('')
        getOrders().then((res) => {
            
            setHasNextPage(res.hasNextPage)
            setListOrders(res.listOrders)
            setLoading(false)
        }).catch(() => {
            setLoading(false)
            enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
                variant: 'error',
            })

        })
    }

    const handleClose = () => {
        history.push('/dashboard')
        setClient(null)
        setProduct(null)
        setQtyCartoni(null)
        setPriceCartoni(null)
        setAddOrderOpen(false)
        setProductList([])
    }


    const handleAddProduct = () => {
        setProduct(null)
        setQtyCartoni(null)
        setPriceCartoni(null)
        setProductList([...productList, { product:{name:null}, price:null, quantity:null }])

    }



    const handleFetchMore = () => {
        setLoadingMore(true)
        setAfter(after + 30)
        getOrders(currentInputSearch, after + 30).then((res) => {
            setLoadingMore(false)
            setHasNextPage(res.hasNextPage)
            setListOrders([...listOrders, ...res.listOrders])
        }).catch((error) => {
            console.log('error', error)
            setLoadingMore(false)
            enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
                variant: 'error',
            })
        })
    }

    const handleSendOrder = async () => {
        setSendingOrder(true)
        try {
            // Verificar aqui esse endpoint
            console.log('currentOrderSend', currentOrderSend)
            await axios.post('/send-order', { id: currentOrderSend.id })
            const res  = await getOrders()
            setHasNextPage(res.hasNextPage)
            setListOrders(res.listOrders)
            setLoading(false)
            setCurrentOrderSend(null)
            setConfirmSendOrder(false)
            enqueueSnackbar('Ordine inviato correttamente', {
                variant: 'success',
            })
        } catch (error) {
            enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
                variant: 'error',
              })
        }finally{
            setSendingOrder(false)
        }
        
    }

    
    
    return (
        <AppBar>
            <Dialog open={confirmDelete !== null}>
                    <CloseIcon onClick={() => setConfirmDelete(null)} style={{float:'right', position:'absolute', right:10, top:10, cursor:'pointer'}} />
                <Box style={{ width: '25rem', padding: '2rem 1rem 1rem 1rem', borderRadius: '12px', }} >
                    <List>
                        <ListItem style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Box style={{ width: '25rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                                <Typography>Sei sicuro di voler eliminare questo prodotto?</Typography>

                                <Box display={'flex'} flexDirection={'row'}>
                                <Button onClick={() => {
                                    setConfirmDelete(null)
                                }} style={{ marginTop: '1rem', width: '6rem', marginRight: '1rem' }} variant='contained' color='default'>{'Annulla'}</Button>
                                <Button onClick={() => {
                                    setConfirmDelete(null)
                                        const productListFiltered = productList.filter(({ id }, i) => {
                                            return confirmDelete !== i
                                        })

                                        setProductList([...productListFiltered])
                                }} style={{ marginTop: '1rem', width: '6rem', backgroundColor: customTheme.colors.ui.red, color: 'white' }} variant='contained'>{'Ellimina'}</Button>
                                </Box>




                            </Box>
                        </ListItem>
                    </List>
                </Box>
            </Dialog>

            <Dialog open={confirmSendOrder} onClose={() => setConfirmSendOrder(false)}>
            <Box
                sx={{
                width: '30rem',
                p: '3rem 2.5rem 2rem 2.5rem',
                borderRadius: '16px',
                position: 'relative',
                }}
            >
                <CloseIcon
                onClick={() => setConfirmSendOrder(false)}
                style={{
                    position: 'absolute',
                    right: 20,
                    top: 20,
                    cursor: 'pointer',
                    opacity: 0.7,
                }}
                />

                <List>
                <ListItem
                    sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    gap: 3,
                    }}
                >
                    <Typography variant="h6" sx={{ fontWeight: 500, lineHeight: 1.4 }}>
                    Sei sicuro di voler inviare l'ordine a{' '}
                    <strong>{currentOrderSend?.client?.nameCompany}</strong>?
                    </Typography>

                    <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 3,
                        mt: 2,
                    }}
                    >
                    <Button
                        onClick={() => setConfirmSendOrder(false)}
                        variant="outlined"
                        style={{ width: '7rem' }}
                    >
                        Annulla
                    </Button>

                    <Button
                        onClick={() => handleSendOrder()}
                        variant="contained"
                        color="primary"
                        style={{ width: '7rem' }}
                    >
                        {sendingOrder ? (
                        <CircularProgress size={20} sx={{ color: 'white' }} />
                        ) : (
                        'Invia'
                        )}
                    </Button>
                    </Box>
                </ListItem>
                </List>
            </Box>
            </Dialog>


            <Dialog
                fullWidth={true}
                maxWidth="md"
                className={classes.dialogContainer}
                open={addOrderOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                
            >
                <CloseIcon onClick={() => handleClose()} style={{float:'right', position:'absolute', right:10, top:10, cursor:'pointer'}} />
                <Box className={classes.contentContainer} style={{opacity: currentOrder?.sent ? 0.7 : 'none', pointerEvents:currentOrder?.sent && 'none'}}>
                    <Box className={classes.titleContainer}>
                        <DialogTitle id="alert-dialog-title" className={classes.title}>
                            Dettagli ordine
                        </DialogTitle>
                    </Box>

                    <div>

                        <Typography style={{marginBottom:'1rem'}}>Clienti</Typography>
                        <AccordionDetails>
                            <Autocomplete
                                options={clients}
                                getOptionLabel={(option) => option.nameCompany ?? ''}
                                value={clients.find((c) => c.id === client) ?? null}
                                onChange={(event, newValue) => {
                                    setClient(newValue ? newValue.id : '');
                                }}
                                sx={{ width: '100%' }}
                                renderInput={(params) => (
                                    <TextField
                                    {...params}
                                    label="Seleziona cliente"
                                    placeholder="Cerca cliente…"
                                    variant="outlined"
                                    fullWidth
                                    />
                                )}
                            />
                            {/* <Select
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left"
                                    },
                                    transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left"
                                    },
                                    getContentAnchorEl: null
                                }}
                                fullWidth={true}
                                variant='outlined'
                                value={client}
                                onChange={(event) => setClient(event.target.value)}
                            >
                                {clients.map(({ id, nameCompany }) => <MenuItem key={id} value={id}>{nameCompany}</MenuItem>)}

                            </Select> */}
                        </AccordionDetails>

                        {productList.map((productLoop, index) => {
                            return <Box style={{ marginBottom: '1rem', marginTop:'1rem' }}>
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                                    <Typography>Prodotti</Typography>
                                    <CloseIcon onClick={() => {
                                            setConfirmDelete(index)
                                        }} style={{ float: 'right', cursor: 'pointer', color: '#FF0000' }} 
                                    />
                                </Box>
                                

                                <Box style={{ display: 'flex', flexDirection: 'row', width: '100%', }}>

                                    <Box width={'70%'} style={{ border: '1px solid', borderColor: customTheme.colors.ui.greyLight, borderRadius: '4px' }}>

                                        <AccordionDetails>
                                            Seleziona prodotto
                                        </AccordionDetails>
                                        <AccordionDetails>

                                            <Autocomplete
                                            
                                                value={productLoop?.product?.name ? { label: productLoop?.product?.name } : null}
                                                options={products}
                                                sx={{ width: 600, zIndex: 2 }}
                                                onChange={(event, values) => {
                                                    const productListChanged = productList.map((pr, ix) => {
                                                        if (pr.id === productLoop.id && index === ix) {
                                                            pr.product.name = values.name
                                                            pr.product.id = values.id
                                                            pr.product.code = values.code
                                                            if(!pr.price){
                                                                const foundProduct = products.find(({name}) => name === values.name)
                                                                pr.product.price = foundProduct.price
                                                            }
                                                            return pr
                                                        } else {
                                                            return pr
                                                        }
                                                    })
                                                    setProductList([...productListChanged])
                                                    setQtyCartoni(0)
                                                    setPriceCartoni(0)
                                                    setProduct(values)
                                                }}
                                                renderInput={(params) => <TextField {...params} label="Prodotti" />}
                                                renderOption={(props, option) => {
                                                    
                                                    const { key, ...optionProps } = props;
                                                    
                                                    return (
                                                        <li key={key} {...optionProps} style={{ pointerEvents:option.name === 'Ultimi acquistati' && 'none', fontWeight: (option.name === 'Ultimi acquistati' || option.totalCount) && 'bold', borderBottom:option.name === 'Ultimi acquistati' && `1px solid ${customTheme.colors.ui.grey}`}}>
                                                            
                                                          <Grid2 container sx={{ alignItems: 'center',   }}>
                                                            
                                                        {option.name}
                                                            
                                                          </Grid2>
                                                         
                                                        </li>
                                                    )
                                                }

                                                }
                                            />
                                        </AccordionDetails>
                                    </Box>
                                    <Box width={'30%'}>
                                        <AccordionDetails>
                                            Qty cartoni
                                        </AccordionDetails>
                                        <AccordionDetails>
                                            <TextField disabled={!productLoop?.product?.name} fullWidth={true} type='number' variant='outlined' InputProps={{ inputProps: { min: 1 } }} value={productLoop.quantity} onChange={event => {
                                                 const productListChanged = productList.map((pr, ix) => {
                                                    if (pr.id === productLoop.id && index === ix) {
                                                        
                                                        pr.quantity =  Number(event.target.value)
                                                        pr.price = Number(pr?.product.price) * Number(event.target.value)
                                                        return pr
                                                    } else {
                                                        return pr
                                                    }
                                                })
                                                setProductList([...productListChanged])
                                               

                                            }} />
                                        </AccordionDetails>
                                    </Box>
                                    
                                </Box>
                                <Divider />

                            </Box>

                        })}


                        {client && <Box style={{ marginTop: '0.5rem', cursor: 'pointer', color: ((!qtyCartoni && productList.length)) && customTheme.colors.ui.grey }} onClick={() => handleAddProduct()}><AddIcon style={{ position: 'relative', top: '0.5rem' }} /> aggiungi prodotto</Box>}




                    </div>
                    {!currentOrder?.sent &&
                    <DialogActions className={classes.dialogActions}>
                        <Button style={{ width: '10rem' }} onClick={() => handleClose()} variant='contained' color='default'>Annulla</Button>
                        <Button  disabled={!canSaveOrder} style={{ width: '10rem' }} onClick={() => (client || productList.length) && handleSave()} variant='contained' color='primary'>
                            {creatingOrder ? <CircularProgress style={{ color: 'white' }} size={22} /> : 'Salva ordine'}
                        </Button>
                    </DialogActions>
                    }

                </Box>
            </Dialog>
            {error ? <GeneralError /> : loading ?
                <main className={classes.content}>
                    <div className={classes.appBarSpacer} />
                    <Typography className={classes.title} variant="h5" gutterBottom component="h2">
                        Gestione ordini
                    </Typography>

                    <Box className={classes.loadingContainer}>
                        <CircularProgress />
                    </Box>
                </main>
                :
                <main className={classes.content}>
                    <div className={classes.appBarSpacer} />

                    <Typography style={{ float: 'left' }} className={classes.title} variant="h5" gutterBottom component="h2">
                        Gestione ordini
                    </Typography>



                    <Button
                        type="submit"
                        fullWidth
                        variant="outlined"
                        style={{ float: 'right', height: '2.5rem', width: '200px', color: customTheme.colors.ui.green, border: `1px solid ${customTheme.colors.ui.green}` }}
                        onClick={() => setAddOrderOpen(true)}
                    >
                        Aggiungi ordine
                    </Button>
                    {/* <Paper
                        component="form"
                        elevation={0}
                        sx={{
                            height: 40,
                            display: 'flex',
                            alignItems: 'center',
                            border: '1px solid',
                            borderColor: 'grey.400',
                            pl: 1,
                            pr: 0.5,
                            width: 320,
                            float: 'right',
                            marginRight: '1rem',
                        }}
                        >
                        <IconButton
                            size="small"
                            sx={{ color: 'grey.700' }}
                            onClick={(e) => {
                            e.preventDefault();
                            if (currentInputSearch) handleSearchOrders();
                            }}
                        >
                            <SearchIcon fontSize="small" />
                        </IconButton>

                        <InputBase
                            value={currentInputSearch}
                            sx={{ flex: 1, fontSize: '0.95rem', ml: 1 }}
                            placeholder="Cerca …"
                            inputProps={{ 'aria-label': 'Cerca' }}
                            onChange={handleInputSearchChange}
                            onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                event.preventDefault();
                                if (currentInputSearch) handleSearchOrders();
                            }
                            }}
                        />

                        {currentInputSearch && (
                            <IconButton
                            size="small"
                            sx={{ color: 'grey.600' }}
                            onClick={(e) => {
                                e.preventDefault();
                                handleClearInput();
                            }}
                            >
                            <CloseIcon fontSize="small" />
                            </IconButton>
                        )}
                    </Paper> */}
                    <SearchBar
                        placeholder='Cerca per codice prodotto…'
                        value={currentInputSearch}
                        onChange={handleInputSearchChange}
                        onSearch={handleSearchOrders}
                        onClear={handleClearInput}
                        sx={{ marginRight: '1rem' }}
                    />

                    <TableContainer style={{ marginTop: '5rem' }}>
                    <InfiniteScroll
                                height={'70vh'}
                                style={{ width: '100%' }}
                                dataLength={listOrders.length}
                                next={handleFetchMore}
                                hasMore={hasNextPage}

                            >
                        
                            <Table
                                sx={{ minWidth: 750 }}
                                aria-labelledby="tableTitle"
                                size={'medium'}
                            >
                                <EnhancedTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={handleRequestSort}
                                    rowCount={rows.length}
                                />
                                <TableBody>
                                    {listOrders.map((row, index) => {
                                        const isAlreadySentToErgon = Number(row?.isArchivedErgon) === 1
                                        const isAlreadySent = Number(row?.sent) === 1

                                        return (
                                            <TableRow
                                                hover
                                                key={row.id}
                                                sx={{ cursor: 'pointer',}}
                                            >

                                                <TableCell align="left" style={{width:'15%'}}>{row.id}</TableCell>
                                                <TableCell align="left" style={{width:'15%'}}>{moment(row.createdAt).format('DD/MM/YYYY')}</TableCell>
                                                <TableCell align="left" style={{width:'15%'}}>{row?.client?.nameCompany}</TableCell>
                                                <TableCell align="left" style={{width:'15%'}}>{row.numProducts}</TableCell>
                                                <TableCell align="left" style={{width:'15%'}}>{row?.orderProducts.map(({product}) => product.code).join('; ')}</TableCell>
                                                {roleUserId !== 2 && <TableCell align="left" style={{width:'15%'}}>{row?.client?.user?.firstName}</TableCell>}
                                                <TableCell aria-describedby={idModifyOrder} style={{ width:'15%',}}  align="left">
                                                    <Box style={{display:'flex', flexDirection:'row',}}>

                                                        {<span style={{ marginRight:'1.5rem', color: customTheme.colors.ui.grey, textDecoration: 'underline', cursor: 'pointer' }} onClick={() => {
                                                            history.push(`/dashboard?id=${row.id}`)
                                                            setAddOrderOpen(true)
                                                            setAnchorElModifyOrder(null)
                                                            setClient(row?.client?.id)
                                                            setCurrentOrder(row)
                                                            const products = [...row?.orderProducts.map((pr) => ({
                                                                ...pr, productId: pr.productId, quantity: pr.quantity, price: pr.price
                                                            }))]
                                                            

                                                            setProductList(products)

                                                            }} >{row.sent ? 'Ordine inviato' : 'Modifica ordine'}
                                                        </span>}

                                                        {!isAlreadySent && !isAlreadySentToErgon && (
                                                        <img
                                                            onClick={() => {
                                                            setCurrentOrderSend(row)
                                                            setConfirmSendOrder(true)
                                                            }}
                                                            src={sendsvgrepo}
                                                            alt="Invia ordine"
                                                        />
                                                        )}
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}

                                </TableBody>
                            </Table>
                        
                        </InfiniteScroll>
                        {loadingMore && <h4 className={classes.loadingMessage}>Caricamento...</h4>}
                    </TableContainer>



                </main>
            }
        </AppBar>
    )
}

export default Dashboard